/**
 * GZOO AI Marketing - White-label branding hook (Wave 6, Phase 1)
 *
 * Returns the active org's resolved branding (logo / name / colours / favicon).
 * Falls back to the GZOO identity when logged out or when the org has no override,
 * so unbranded usage is identical to before.
 */
'use client';

import { useAuth, type Branding } from './useAuth';

// The GZOO identity — mirrors backend GZOO_DEFAULT_BRANDING so a logged-out shell or a
// not-yet-loaded /auth/me still renders correctly.
export const GZOO_BRANDING: Branding = {
  app_name: 'GZOO AI Marketing',
  logo_url: 'https://cdn.gzoo.net/logo-orange.webp',
  logo_icon_url: 'https://cdn.gzoo.net/favicon.png',
  favicon_url: 'https://cdn.gzoo.net/favicon.png',
  primary_color: '#FF6B00',
  accent_color: '#FF6B00',
  background_color: '#030712',
  is_custom: false,
};

export function useBranding(): Branding {
  const { user, isAuthenticated } = useAuth();
  if (isAuthenticated && user?.active_branding) {
    return user.active_branding;
  }
  return GZOO_BRANDING;
}
